module.exports = {
  internal: 'internal',
  external: 'external'
}